import { ArrowDown, ArrowUp } from "lucide-react";
import React from "react";

import { IgChip, IgTypography } from "@intelligems/ig-theme";
import { ChipProps, useTheme } from "@mui/material";

interface UpliftChipProps extends ChipProps {
  upliftValue: number;
  impactCalculationColoring?: "inverted" | "neutral" | "normal";
}

export const UpliftChip = (props: UpliftChipProps) => {
  const { upliftValue, impactCalculationColoring } = props;
  const theme = useTheme();
  const isZero = Math.round(upliftValue * 100) === 0;
  const isPositive = upliftValue > 0;
  const color =
    isZero || impactCalculationColoring === "neutral"
      ? "default"
      : impactCalculationColoring === "inverted"
        ? isPositive
          ? "error"
          : "success"
        : isPositive
          ? "success"
          : "error";

  const backgroundColor =
    isZero || impactCalculationColoring === "neutral"
      ? theme.igPrimitives.gray[600]
      : impactCalculationColoring === "inverted"
        ? isPositive
          ? theme.igPrimitives.red[300]
          : theme.igPrimitives.lime[50]
        : isPositive
          ? theme.igPrimitives.lime[50]
          : theme.igPrimitives.red[300];

  const label = (
    <IgTypography
      variant={"body2"}
      sx={{
        display: "flex",
        alignItems: "center",
        color: color,
        padding: "0px",
        fontWeight: 600,
        marginBottom: "1px",
      }}
    >
      {isZero ? undefined : isPositive ? (
        <ArrowUp
          size={16}
          color={
            impactCalculationColoring === "neutral"
              ? theme.igIconColors.light
              : impactCalculationColoring === "inverted"
                ? theme.igIconColors.error
                : theme.igIconColors.success
          }
          style={{
            padding: "0px",
            marginBottom: "2px",
          }}
        />
      ) : (
        <ArrowDown
          size={16}
          color={
            impactCalculationColoring === "neutral"
              ? theme.igIconColors.light
              : impactCalculationColoring === "inverted"
                ? theme.igIconColors.success
                : theme.igIconColors.error
          }
          style={{
            padding: "0px",
            marginBottom: "1px",
          }}
        />
      )}
      {Math.round(Math.abs(upliftValue * 100))}%
    </IgTypography>
  );

  return (
    <IgChip
      color={color}
      label={label}
      sx={{
        // height: "24px",
        width: isZero ? "35px" : "51px",
        padding: "0px",
        // borderRadius: "10px",
        backgroundColor: backgroundColor,
        marginRight: "10px",
        paddingTop: "3px",
        "& .MuiChip-label": {
          padding: "0px",
          paddingRight: isZero ? "0px" : "5px",
        },
      }}
    />
  );
};
